<template>
  <wegow-button
    button-id="buy-btn"
    class="h-[58px]"
    :text="$t('wegow.purchase.buy')"
    background="opacity"
    color="topaz-light"
    size="xl"
    font-size="xl"
    type="button"
    @click="navigateTo(eventDetail.options[0])"
  />
</template>

<script setup>
import { event } from "vue-gtag";
import WegowButton from "@/components/general/forms/WegowButton";
import apiService from "@/api/ApiService";
import { useEvent } from "@/composables/useEvent";
import {
  validateFollowVenue,
  validateFollowArtist
} from "@/plugins/errors/validations/user-validations";
import {
  FollowArtistError,
  FollowVenueError
} from "@/plugins/errors/user-errors";

// Variables
const { details: eventDetail } = useEvent();

// Methods
const gaEvent = option => {
  event("external_sell", {
    event_name: eventDetail.value.title,
    spider_name: option?.aggregator?.name || option?.name || "",
    post_category: "affiliates"
  });
};
const followArtist = async () => {
  const params = {
    artist:
      eventDetail.value?.artists.length > 0
        ? eventDetail.value?.artists[0]?.id
        : null
  };
  try {
    await apiService.post("/user_artists/", params);
  } catch (error) {
    validateFollowArtist(error);
  }
};
const followVenue = async () => {
  const params = {
    venue: eventDetail.value.venue.id
  };
  try {
    await apiService.post("/user_venues/", params);
  } catch (error) {
    validateFollowVenue(error);
  }
};

// ErrorsHandler
const followArtistHandler = async () => {
  try {
    await followArtist();
  } catch (error) {
    if (error instanceof FollowArtistError) {
      console.error("Error siguiendo al artista:", error.message);
    } else {
      console.error("Error desconocido:", error);
    }
  }
};
const followVenueHandler = async () => {
  try {
    await followVenue();
  } catch (error) {
    if (error instanceof FollowVenueError) {
      console.error("Error siguiendo a la sala:", error.message);
    } else {
      console.error("Error desconocido:", error);
    }
  }
};

const navigateTo = async option => {
  gaEvent(option);
  await followVenueHandler();
  await followArtistHandler();
  // await sendPixelData(option);
  window.open(option.url, "_blank");
};
</script>
